<template>
<div class="session-detail-wrapper">
    <div v-if="loading">
        <img class="hidden-md hidden-sm hidden-xs" src="/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/Speaker_Placeholder_Desktop_v1.svg" alt="">
        <img class="hidden-lg hidden-sm hidden-xs" src="/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/Speaker_Placeholder_Tablet_v1.svg" alt="">
        <img class="hidden-md hidden-lg" src="/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/Speaker_Placeholder_Mobile_v1.svg" alt="">
    </div>
    <div v-if="!loading && speakers && speakers.length">
        <h3 class="my-3 text-block mb-5">OUR SPEAKERS LINE UP</h3>
        <div class="d-flex flex-wrap">
            <div class="col-6 col-md-4 col-lg-3 mb-4" v-for="(aSpeaker, index) in speakers" :key="index">
                <div v-if="aSpeaker && aSpeaker.slug">
                    <router-link :to="`/speaker/${aSpeaker.slug}`">
                        <div class="sands-image-colored-overlay-hover text-center">
                            <img class="box-border-radius" v-if="aSpeaker.avatarSquareSmall && aSpeaker.avatarSquareSmall.xxx && aSpeaker.avatarSquareSmall.xxx !== 'null'" :src="aSpeaker.avatarSquareSmall.xxx" alt="">
                            <img class="box-border-radius" v-else src="/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/avatarSquareLarge_xx_mustermann_max_ek_1558018462305.png" alt="">
                        </div>
                    </router-link>
                </div>
                <div class="text-center my-3 gdlr-speaker-item-content">
                    <h3 class="gdlr-skin-title gdlr-speaker-item-title">
                        <router-link v-if="aSpeaker.forename && aSpeaker.surname && aSpeaker.slug" :to="`/speaker/${aSpeaker.slug}`">{{aSpeaker.forename}}&nbsp;{{aSpeaker.surname}}</router-link>
                        <span v-if="aSpeaker.forename && aSpeaker.surname && !aSpeaker.slug">{{aSpeaker.forename}}&nbsp;{{aSpeaker.surname}}</span>
                    </h3>
                    <div v-if="aSpeaker.company" class="gdlr-speaker-item-position gdlr-info-font gdlr-skin-info">{{aSpeaker.company}}</div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    ApolloClient,
    InMemoryCache
} from '@apollo/client/core'
import {
    provideApolloClient,
    useQuery
} from "@vue/apollo-composable";
import CONCORD_QUERIES from "../services/concord_queries.js"
import {
    watch
} from 'vue'
import {
    useRoute
} from 'vue-router'
export default {
    name: 'expertsListing',
    props: {
        settingsPerm: Object
    },
    data() {
        return {
            loading: true,
            speakers: false,
            seriesId: this.settingsPerm.seriesId,
        };
    },
    setup() {
        const route = useRoute();
        return route;
    },
    mounted() {
        window.scrollTo(0, 0);
    },
    created() {
        this.emitter.emit('infoFromChild', {'isSpeakerListing':true});
        this.emitter.emit('tracksRelatedSessions', false);
        const cache = new InMemoryCache();
        const apolloClient = new ApolloClient({
            cache,
            uri: this.settingsPerm.concordBackendURL,
        })
        provideApolloClient(apolloClient)
        let variablesForQuery = {
            conferenceSeriesId: this.seriesId,
            page: 1,
            pagesize: 130
        };
        const {
            result
        } = useQuery(CONCORD_QUERIES.SPEAKER_QUERY, variablesForQuery);
        watch(result, value => {
            if (value && value.vueExperts && value.vueExperts.Experts && value.vueExperts.Experts.length) {
                this.loading = false;
                this.speakers = value.vueExperts.Experts;
            } else {
                this.loading = false;
            }
        })
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.gdlr-speaker-item-title {
    font-size: 15px;
    text-transform: none;
    font-weight: bold;
    letter-spacing: 2px;
    margin-bottom: 7px;
}
.sands-image-colored-overlay-hover img{
    height: 173px;
    width: 247px;
}
@media screen and (max-width: 992px) {
.sands-image-colored-overlay-hover img{
    height: 150px;
    width: 150px;
    object-fit: cover;
}
}
</style>
